import { object, string } from 'yup';

export const validationSchema = object().shape({
  description: string().required('Campo obrigatório').max(400, 'Deve ter no máximo 400 caracteres'),
});
